<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search"></div>
            <div class="btn_box">
                <el-button class="new_btn"
                           @click="openNew"
                           type="primary"
                           size="small">新建角色
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      :stripe="true"
                      highlight-current-row
                      height="100%"
                      width="100%">
                <el-table-column type="index" label="序号" width="65" fixed="left"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :label="item.label"
                                 :prop="item.prop"
                                 :width="item.width"
                                 :fixed="item.fixed"
                                 :formatter="item.formatter"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="权限概述">
                    <template slot-scope="scope">
                        <span>{{scope.row.authority | selectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="edit_btn"
                                   @click="openLook(scope.row)"
                                   size="mini">查看
                        </el-button>
                        <el-button class="edit_btn"
                                   @click="openEdit(scope.row)"
                                   size="mini">修改
                        </el-button>
                        <el-button class="table_del_btn"
                                   type="text"
                                   @click="delRow(scope.row)"
                                   size="mini">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
<!--
        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>-->
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
export default {
    name: "tableView",
    components: {
    },
    data() {
        return {
            tableData: [],
            columnData: [
                {label: '角色名称', prop: 'name', width: 150},
                {label: '角色备注', prop: 'remark', width: 300},
            ],
            // 分页
            currentPage: 1,
            total: 0,
            pageSize: 20,
        }
    },
    filters: {
        selectName(val) {
            let text = '';
            if (val.indexOf('bank-article') > -1) {
                if (text === '') {
                    text = '图文'
                } else {
                    text = text + '、图文'
                }
            }
            if (val.indexOf('bank-questionnaire') > -1) {
                if (text === '') {
                    text = '问卷管理'
                } else {
                    text = text + '、问卷管理'
                }
            }
            if (val.indexOf('bank-greetings') > -1) {
                if (text === '') {
                    text = '问候语'
                } else {
                    text = text + '、问候语'
                }
            }
            if (val.indexOf('bank-remind') > -1) {
                if (text === '') {
                    text = '通用提醒'
                } else {
                    text = text + '、通用提醒'
                }
            }
            if (val.indexOf('push-life') > -1) {
                if (text === '') {
                    text = '内容推送'
                } else {
                    text = text + '、内容推送'
                }
            }
            if (val.indexOf('sys') > -1) {
                if (text === '') {
                    text = '运营用户'
                } else {
                    text = text + '、运营用户'
                }
            }

            if (val.indexOf('staff-staff') > -1) {
                if (text === '') {
                    text = '组织架构'
                } else {
                    text = text + '、组织架构'
                }
            }
            if (val.indexOf('ill-ill') > -1) {
                if (text === '') {
                    text = '病种管理'
                } else {
                    text = text + '、病种管理'
                }
            }

            if (val.indexOf('hos-hos') > -1) {
                if (text === '') {
                    text = '医院管理'
                } else {
                    text = text + '、医院管理'
                }
            }
            if (val.indexOf('sys') > -1) {
                if (text === '') {
                    text = '系统用户'
                } else {
                    text = text + '、系统用户'
                }
            }
            if (val.indexOf('patient') > -1) {
                if (text === '') {
                    text = '患者数据'
                } else {
                    text = text + '、患者数据'
                }
            }
            if (val.indexOf('sick-audit') > -1) {
                if (text === '') {
                    text = '注册审核'
                } else {
                    text = text + '、患者审核'
                }
            }
            if (val.indexOf('bill-audit') > -1) {
                if (text === '') {
                    text = '发票审核'
                } else {
                    text = text + '、发票审核'
                }
            }
            if (val.indexOf('patient') > -1) {
                if (text === '') {
                    text = '患者数据'
                } else {
                    text = text + '、患者数据'
                }
            }
            if (val.indexOf('schedule') > -1) {
                if (text === '') {
                    text = '填报进度'
                } else {
                    text = text + '、填报进度'
                }
            }
            if (val.indexOf('operation-operation') > -1) {
                if (text === '') {
                    text = '操作日志'
                } else {
                    text = text + '、操作日志'
                }
            }
            if (val.indexOf('dictionaries-dictionaries') > -1) {
                if (text === '') {
                    text = '字典管理'
                } else {
                    text = text + '、字典管理'
                }
            }

            return text;
        }
    },
    mounted() {
        this.getTableData()
    },
     methods: {
         ...mapMutations('sysUserData', {
             setRoleTitle: 'setRoleTitle',
             setRowData: 'setRowData',
         }),
         openNew() {
             let data = {
                 title: '角色新增',
                 look: true
             };
             this.setRoleTitle(data);
             this.$emit('changeTopTab', 'roleAdd')
         },
         openLook(row) {
             console.log(row);
             let data = {
                 title: '角色查看',
                 look: true
             };
             this.setRoleTitle(data);
             let params = {
                 form: {
                     name: row.name,
                     remark: row.remark,
                     role_id: row.role_id,
                 },
                 authority: JSON.parse(row.authority)
             };
             this.setRowData(params);
             this.$emit('changeTopTab', 'roleEdit')
         },
         openEdit(row) {
             console.log(row);
             let data = {
                 title: '角色修改',
                 look: false
             };
             this.setRoleTitle(data);
             let params = {
                 form: {
                     name: row.name,
                     remark: row.remark,
                     role_id: row.role_id,
                 },
                 authority: JSON.parse(row.authority)
             };
             this.setRowData(params);
             this.$emit('changeTopTab', 'roleEdit')
         },
         delRow(row) {
             // 当前页全部删除后进入上一页
             let listLength = this.tableData.length;
             let nowPage = this.currentPage;
             if (listLength === 1) {
                 if (this.currentPage > 1) {
                     nowPage = this.currentPage - 1
                 } else {
                     nowPage = 1
                 }
             }
             const that = this;
             this.$confirm('是否删除?').then(() => {
                 this.httpDel(`/role/${row.role_id}`).then(res => {

                     if (res.user) {
                         that.$confirm('检测到该角色已关联用户，是否删除？').then(() => {
                             let params = {
                                 status: 1
                             };
                             that.httpDel(`/role/${row.role_id}`, params).then(data => {
                                 if (data.code === 0) {
                                     that.$message.success('已成功删除！');
                                     that.getTableData(nowPage);
                                 }
                             })
                         }).catch(() => {})

                     } else {
                         this.$message.success('已成功删除！');
                         this.getTableData(nowPage);
                     }
                 })
             })
         },
         handleCurrentChange(val) {
             this.getTableData(val)
         },
         getTableData(v = 1) {
             let params = {
                 page: v,
                 page_size: this.pageSize
             };
             this.httpGet('/role', params).then(res => {
                 this.tableData = res.data.data_list;
                 this.total = res.total || 0;
                 this.$nextTick(() => {this.currentPage = v;});
             })
         }
    }
}
</script>

<style scoped lang="scss">
.context {
    width: 100%;
    height: 100%;
}
</style>